"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_EMPLOYEES = exports.MIN_EMPLOYEES = exports.MAX_REVENUE = exports.MIN_REVENUE = void 0;
var MIN_REVENUE = 'MIN_REVENUE';
exports.MIN_REVENUE = MIN_REVENUE;
var MAX_REVENUE = 'MAX_REVENUE';
exports.MAX_REVENUE = MAX_REVENUE;
var MIN_EMPLOYEES = 'MIN_EMPLOYEES';
exports.MIN_EMPLOYEES = MIN_EMPLOYEES;
var MAX_EMPLOYEES = 'MAX_EMPLOYEES';
exports.MAX_EMPLOYEES = MAX_EMPLOYEES;